export const NATIVE_APP_DRAWER_STORAGE_KEY = 'native-app-drawer-reminder';
